import { customerCanChangeGenerationLanguage } from 'src/data/accessRights';

import { useCurrentCustomer } from './useCurrentCustomer';

export const useCustomerCanChangeGenerationLanguage = () => {
  const currentCustomer = useCurrentCustomer();
  return customerCanChangeGenerationLanguage(currentCustomer);
};
